import * as React from 'react'
import { MutableRefObject } from 'react'
import { IList, ISelection, MessageBar, MessageBarType } from '@fluentui/react'
import Loading from '../../../components/Loading'
import { Destination } from '../../../context/AxiosContext'
import EmailListItem from './EmailListItem'
import BaseList from '../../../components/List/BaseList'
import { SelectableEmail } from '../../../hooks/email/useProcessEmail'
import { Recipient } from '@microsoft/microsoft-graph-types'

export type EmailItem = {
    id: string
    internetMessageId: string
    conversationId: string
    url: string
    webUrl?: string
    destination: Destination
    type: EmailType
    recipient: string
    recipients: Recipient[]
    sender: Recipient
    subject: string
    snippet: string
    date: string
    hasAttachment: boolean
}

export enum EmailType {
    In = 'Inbox',
    Out = 'Send',
}

type Props = {
    componentRef: MutableRefObject<IList>
    items: EmailItem[]
    isLoading: boolean
    hasMessages: boolean
    showLocation: boolean
    selection?: ISelection<SelectableEmail>
}

export default function EmailList({ componentRef, items, isLoading, hasMessages, showLocation, selection }: Props) {
    if (isLoading) {
        return <Loading />
    }

    if (hasMessages && (items || []).length === 0) {
        return (
            <MessageBar messageBarType={MessageBarType.info}>
                Er zijn geen berichten met de huidige selectie.
            </MessageBar>
        )
    }

    return (
        <BaseList<EmailItem> items={items} componentRef={componentRef}>
            {(item?: EmailItem, index?: number) => (
                <EmailListItem item={item} index={index} showLocation={showLocation} selection={selection} />
            )}
        </BaseList>
    )
}
